import { Component } from '@angular/core';

@Component({
    selector: 'app-consult-card',
    imports: [],
    templateUrl: './consult-card.component.html',
    styleUrl: './consult-card.component.css'
})
export class ConsultCardComponent {

}
